// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e19e8d15","389":"5081d5d8","455":"e8d68a20","857":"afd12ac7","977":"d1ea0dc7"}[chunkId] + ".chunk.js";
};